import { render, staticRenderFns } from "./AbkSurveyQuestionFieldForm.vue?vue&type=template&id=1b15ab8a&scoped=true&"
import script from "./AbkSurveyQuestionFieldForm.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyQuestionFieldForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyQuestionFieldForm.vue?vue&type=style&index=0&id=1b15ab8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15ab8a",
  null
  
)

export default component.exports